import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import EpiContext from '@episerver/spa-core/Spa';
import TooltipPackageInfo from '../../Tooltip/TooltipPackageInfo';
import {isMobile} from 'react-device-detect';

const InternetPackage = (props) => {
  const isFiber = props.selectedSubscriber?.internetSubType != 'InfraBezeq';
  const displayProductStatus =
    props.selectedSubscriber?.productStatus != 'Active' &&
    props.selectedSubscriber?.productStatus != 'INS' &&
    props.selectedSubscriber?.productStatus != 'A';
  const displayTooltip =
    props.selectedSubscriber?.ban != null &&
    props.selectedSubscriber?.ban != '' &&
    props.selectedSubscriber?.createdInSystem?.toUpperCase() == 'JET';

  function getInternetBoxDetails() {
    const downloadSpeed = props.selectedSubscriber?.downloadSpeed;
    const isBundle = props.selectedSubscriber.isBundle;
    switch (props.selectedSubscriber.internetProductType) {
      case 'Internet':
      case 'InternetInfra':
        const internetTitle = props.selectedSubscriber?.internetSubType != 'InfraBezeq' ? 'אינטרנט סיבים' : 'אינטרנט ביתי';
        const internetEquipmentUrl = props.iContent.internetEquipmentUrl.value;
        return (
          <>
            <div className='internet-infrastructure-details-wrapper'>
              <div className='internet-details-wrapper'>
                <div className='title'>
                  {internetTitle} {displayTooltip && <TooltipPackageInfo position={isMobile ? 'left' : 'right'} />}
                </div>
                {isBundle && <div className='is-bundle'>חלק מחבילה משולבת</div>}
                {displayProductStatus && <div className='status'>{props.selectedSubscriber?.productStatusDesc}</div>}
                {downloadSpeed && (
                  <div>
                    מהירות {isFiber ? 'הורדה' : 'גלישה'} : עד {downloadSpeed}Mb
                  </div>
                )}
              </div>
              {props.selectedSubscriber.equipments?.length > 0 && (
                <div className='internet-details-wrapper equipments'>
                  <div className='title'></div>
                  {props.selectedSubscriber.equipments?.map((equipment, index) => {
                    return <div key={index}>{equipment.productDescription50 ?? equipment.productDescription}</div>;
                  })}
                  {internetEquipmentUrl && (
                    <a href='#' onClick={() => EpiContext.navigateTo(internetEquipmentUrl)}>
                      לרשימת כל הציוד שלי {window.Config.brand_Name_HE}
                    </a>
                  )}
                </div>
              )}
            </div>
            {props.selectedSubscriber.mapaItem && (
              <div className='internet-details-wrapper mapa'>
                <div className='title'>טלפון ביתי {displayTooltip && <TooltipPackageInfo position={isMobile ? 'left' : 'right'} />}</div>
                {isBundle && <div className='is-bundle'>חלק מחבילה משולבת</div>}
                {displayProductStatus && <div className='status'>{props.selectedSubscriber?.productStatusDesc}</div>}
                <div>{props.selectedSubscriber.mapaItem?.subscriberNumber}</div>
              </div>
            )}
          </>
        );
      case 'InternetIsp':
        const username = props.selectedSubscriber.productSubscriberNo?.split('@')[0];
        const email = props.selectedSubscriber.email ?? props.selectedSubscriber.productSubscriberNo;
        return (
          <div className=''>
            <div className={`internet-details-wrapper ${isBundle && isMobile ? 'p-3' : 'center'}`}>
              <div className={`title ${isBundle && isMobile ? '' : 'centre'}`}>
                ספק אינטרנט {displayTooltip && <TooltipPackageInfo position={isMobile ? 'left' : 'right'} />}
              </div>
              {isBundle && <div className='is-bundle'>חלק מחבילה משולבת</div>}
              {displayProductStatus && <div className='status'>{props.selectedSubscriber?.productStatusDesc}</div>}
              {downloadSpeed && <div className='speed'>מהירות גלישה : עד {downloadSpeed}Mb</div>}
              <div>משתמש: {username}</div>
              {email && <div>כתובת דוא"ל: {email}</div>}
            </div>
            {props.selectedSubscriber.mapaItem && (
              <div className={`internet-details-wrapper mapa ${isBundle && isMobile ? '' : 'center'}`}>
                <div className={`title ${isBundle && isMobile ? '' : 'center'}`}>
                  טלפון ביתי {displayTooltip && <TooltipPackageInfo position={isMobile ? 'left' : 'right'} />}
                </div>
                {isBundle && <div className='is-bundle'>חלק מחבילה משולבת</div>}
                {displayProductStatus && <div className='status'>{props.selectedSubscriber?.productStatusDesc}</div>}
                <div>{props.selectedSubscriber.mapaItem?.subscriberNumber}</div>
              </div>
            )}
          </div>
        );
      case 'Mapa':
        return (
          <div className='internet-details-wrapper'>
            <div className='title'>טלפון ביתי {displayTooltip && <TooltipPackageInfo position={isMobile ? 'left' : 'right'} />}</div>
            {displayProductStatus && <div className='status'>{props.selectedSubscriber?.productStatusDesc}</div>}
            <div>{props.selectedSubscriber?.productSubscriberNo}</div>
          </div>
        );
      default:
        break;
    }
  }

  return (
    <div className='selfcare-internet-package'>
      {props.isFetchData && props.selectedSubscriber ? (
        <div className='selfcare-internet-package-wrapper'>{getInternetBoxDetails()}</div>
      ) : (
        <div style={{display: 'flex', flex: '1', flexDirection: 'column', gap: '1px'}}>
          <Skeleton height={145} animation='wave' />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isFullAuthenticated: state.authentication?.loginData?.isFullAuthenticated,
    selectedSubscriber: state.selfcarePage?.selectedSubscriber,
    isFetchData: state.selfcarePage?.isFetchData,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InternetPackage);
